<template>
  <div>
    <div class="sub-title">
      <h3>{{ subTitle }}</h3>
    </div>
    <p class="content" v-html="content"></p>
  </div>
</template>

<script>
export default {
  name: "LineInfoText",
  props: {
    subTitle: {
      type: String,
    },
    content: {
      type: String,
    },
  },
};
</script>
